export default "__VITE_ASSET__D8Q5A$cx__"